import * as React from 'react';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { NavLink, useLocation } from 'react-router-dom';

export default function MobileNavigation({ sections }) {
  const location = useLocation();
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <Box components="nav" role="navigation">
      <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleOpenNavMenu}
          color="primary"
        >
          <MenuIcon />
        </IconButton>

        <Menu
          id="menu-appbar"
          anchorEl={anchorElNav}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={Boolean(anchorElNav)}
          onClose={handleCloseNavMenu}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiMenu-paper': { border: 'none' },
          }}
        >
          {sections.map((section, index) => (
            <MenuItem
              key={`mobile_${section.text}_${index}`}
              sx={{ padding: 0 }}
            >
              <NavLink
                key={`${section.text}_${index}`}
                to={section.link}
                className={() => {
                  // Manually set active state since we don't have any top level pages
                  return location.pathname.split('/')[1] ===
                    section.link.split('/')[1]
                    ? 'active'
                    : '';
                }}
                style={{
                  textDecoration: 'none',
                }}
              >
                <Typography
                  variant="span"
                  sx={{
                    color: 'primary.main',
                    display: 'block',
                    paddingX: 3,
                    paddingY: 1,
                    '&:hover': {
                      backgroundColor: 'primary.light',
                    },
                    '.active &': {
                      fontWeight: 700,
                      backgroundColor: 'primary.main',
                      color: 'common.white',
                    },
                  }}
                >
                  {section.text}
                </Typography>
              </NavLink>
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </Box>
  );
}
